"use client";

import { usePathname } from "next/navigation";
import Script from "next/script";
import { useEffect, useState } from "react";

export const MetaPixel = ({ pixelId }: { pixelId: string }) => {
	const [loaded, setLoaded] = useState(false);
	const pathname = usePathname();

	// biome-ignore lint/correctness/useExhaustiveDependencies: both are needed
	useEffect(() => {
		if (!loaded) {
			return;
		}

		pageview();
	}, [pathname, loaded]);

	return (
		<Script
			id="fb-pixel"
			strategy="afterInteractive"
			onLoad={() => setLoaded(true)}
			data-pixel-id={pixelId}
			src={`/_public/scripts/pixel.js`}
		/>
	);
};

const pageview = () => {
	window.fbq("track", "PageView");
};

// https://developers.facebook.com/docs/facebook-pixel/advanced/
const _event = (name: string, options = {}) => {
	window.fbq("track", name, options);
};
